import { logError } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Overview } from '@com-delta-idp/mnx-sky-club-ui';
import {
  AEMErrorMessage,
  getEmptyContent,
  isDisplay,
  isValidData
} from '@com-delta-idp/mnx-skymiles-shared';
import { AEMOverviewContent, PurchaseResponse } from '../models';

export const getOverview = (
  aem: AEMOverviewContent | undefined,
  aemErrorMessages: AEMErrorMessage[] | undefined,
  featureFlag: boolean | undefined,
  purchaseResponse?: PurchaseResponse
): Overview => {
  try {
    return isValidData<
      AEMOverviewContent,
      [AEMOverviewContent | undefined, boolean | undefined]
    >('title', aem, featureFlag)
      ? adaptOverview(
          aem as AEMOverviewContent,
          featureFlag as boolean,
          purchaseResponse
        )
      : isDisplay<Overview>(featureFlag);
  } catch (error) {
    logError(
      error as Error,
      'DIGITAL_CUSTOMER_LOYALTY',
      'SKY_CLUB',
      'OVERVIEW'
    );
    return getEmptyContent<Overview>('overview', aemErrorMessages, true, true);
  }
};

export const adaptOverview = (
  aem: AEMOverviewContent,
  featureFlag: boolean,
  purchaseResponse?: PurchaseResponse
): Overview => {
  return featureFlag
    ? {
        ...aem,
        expires: !!purchaseResponse?.activeMemberExpirationDate,
        expiryDate: purchaseResponse?.activeMemberExpirationDate,
        disabled: false,
        loaded: true
      }
    : getEmptyContent<Overview>('', [], true, true);
};
